module.exports = __webpack_public_path__ + "img/vehicledefault.39db3553.png";